import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import Ctrl from './controller';
import { InfoEventModal, HourInfoModal, IconModal, BarSeparateInfo } from "./style"
import { Dropdown, MenuDropdown } from "trainfes-components-library";
import ModalSimple from "../../components/modalSimple";
import { ChartDonut } from "../../components/charts";
import { Row, Col } from '../../components/grilla/grid.component'


const statusList = [
    { translationKey: "scheduled", value: 1 },
    { translationKey: "confirmed", value: 4 },
    { translationKey: "done", value: 2 },
    { translationKey: "canceled", value: 3 },
    { translationKey: "in_progress", value: 5 }
];

const statusListAsync = [
    { translationKey: "pending", value: 0 },
    { translationKey: "done", value: 1 },
    { translationKey: "finish", value: 2 },
    { translationKey: "to_recover", value: 4 }
];

const translateStatusList = (list, t) => {
    return list.map(item => ({
        ...item,
        label: t(`status_list.${item.translationKey}`)
    }));
};

const translateStatusListAsync = (list, t) => {
    return list.map(item => ({
        ...item,
        label: t(`statusList_Async.${item.translationKey}`)
    }));
};

const getStatusTranslationKey = (statusValue) => {
    switch (statusValue) {
        case 0:
            return "pending";
        case 1:
            return "done";
        case 2:
            return "finish";
        case 4:
            return "to_recover";
        default:
            return "";
    }
};

export const InputCheckBox = ({ events, allEvents, data, index, onEvents, onFinallyPlanning, ...props }) => {
    const { t } = useTranslation("data_clinical");

    const checkValue = (ev, id) => {
        ev.persist();
        Ctrl.checkValueEvent(ev.target.checked, id, events, allEvents)
            .then(res => onEvents(res))
            .catch(err => console.log(err));
    };

    return (
        <Row>
            <Col md={11}>
                <FormControlLabel
                    className="m-0"
                    control={<Checkbox defaultChecked={true} onChange={(ev) => checkValue(ev, data._id)} />}
                    label={`${data.name != null ? data.name : " - "}`}
                />
            </Col>
            <Col md={1}>
                <MenuDropdown
                    icon={<div className="_icon pointer mt-1">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" datatoggle="dropdown" aria-expanded="false">
                            <path d="M12 7C12.3956 7 12.7822 6.8827 13.1111 6.66294C13.44 6.44318 13.6964 6.13082 13.8478 5.76537C13.9991 5.39992 14.0387 4.99778 13.9616 4.60982C13.8844 4.22186 13.6939 3.86549 13.4142 3.58579C13.1345 3.30608 12.7781 3.1156 12.3902 3.03843C12.0022 2.96126 11.6001 3.00087 11.2346 3.15224C10.8692 3.30362 10.5568 3.55996 10.3371 3.88886C10.1173 4.21776 10 4.60444 10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7ZM12 17C11.6044 17 11.2178 17.1173 10.8889 17.3371C10.56 17.5568 10.3036 17.8692 10.1522 18.2346C10.0009 18.6001 9.96126 19.0022 10.0384 19.3902C10.1156 19.7781 10.3061 20.1345 10.5858 20.4142C10.8655 20.6939 11.2219 20.8844 11.6098 20.9616C11.9978 21.0387 12.3999 20.9991 12.7654 20.8478C13.1308 20.6964 13.4432 20.44 13.6629 20.1111C13.8827 19.7822 14 19.3956 14 19C14 18.4696 13.7893 17.9609 13.4142 17.5858C13.0391 17.2107 12.5304 17 12 17ZM12 10C11.6044 10 11.2178 10.1173 10.8889 10.3371C10.56 10.5568 10.3036 10.8692 10.1522 11.2346C10.0009 11.6001 9.96126 12.0022 10.0384 12.3902C10.1156 12.7781 10.3061 13.1345 10.5858 13.4142C10.8655 13.6939 11.2219 13.8844 11.6098 13.9616C11.9978 14.0387 12.3999 13.9991 12.7654 13.8478C13.1308 13.6964 13.4432 13.44 13.6629 13.1111C13.8827 12.7822 14 12.3956 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10Z" fill="black" />
                        </svg>
                    </div>}
                    items={[{ anchor: t('finish'), onClick: () => onFinallyPlanning(data) }]}
                />
            </Col>
        </Row>
    );
};

export const InputCheckBoxSchedule = ({ data, index, schedules, eventsSchedules, onSchedules, onFinallyPlanning, ...props }) => {
    const { t } = useTranslation("data_clinical");
    const checkValue = (ev, id) => {
        ev.persist();
        Ctrl.checkValueSchedule(ev.target.checked, id, schedules, eventsSchedules)
            .then(res => onSchedules(res))
            .catch(err => console.log(err));
    };

    return (
        <Row>
            <Col md={11}>
                <FormControlLabel
                    className="m-0"
                    control={<Checkbox defaultChecked={true} onChange={(ev) => checkValue(ev, data._id)} />}
                    label={`${data.name != null ? data.name : " - "}`}
                />
            </Col>
            <Col md={1}>
                <MenuDropdown
                    icon={<div className="_icon pointer mt-1">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" dataToggle="dropdown" ariaExpanded="false">
                            <path d="M12 7C12.3956 7 12.7822 6.8827 13.1111 6.66294C13.44 6.44318 13.6964 6.13082 13.8478 5.76537C13.9991 5.39992 14.0387 4.99778 13.9616 4.60982C13.8844 4.22186 13.6939 3.86549 13.4142 3.58579C13.1345 3.30608 12.7781 3.1156 12.3902 3.03843C12.0022 2.96126 11.6001 3.00087 11.2346 3.15224C10.8692 3.30362 10.5568 3.55996 10.3371 3.88886C10.1173 4.21776 10 4.60444 10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7ZM12 17C11.6044 17 11.2178 17.1173 10.8889 17.3371C10.56 17.5568 10.3036 17.8692 10.1522 18.2346C10.0009 18.6001 9.96126 19.0022 10.0384 19.3902C10.1156 19.7781 10.3061 20.1345 10.5858 20.4142C10.8655 20.6939 11.2219 20.8844 11.6098 20.9616C11.9978 21.0387 12.3999 20.9991 12.7654 20.8478C13.1308 20.6964 13.4432 20.44 13.6629 20.1111C13.8827 19.7822 14 19.3956 14 19C14 18.4696 13.7893 17.9609 13.4142 17.5858C13.0391 17.2107 12.5304 17 12 17ZM12 10C11.6044 10 11.2178 10.1173 10.8889 10.3371C10.56 10.5568 10.3036 10.8692 10.1522 11.2346C10.0009 11.6001 9.96126 12.0022 10.0384 12.3902C10.1156 12.7781 10.3061 13.1345 10.5858 13.4142C10.8655 13.6939 11.2219 13.8844 11.6098 13.9616C11.9978 14.0387 12.3999 13.9991 12.7654 13.8478C13.1308 13.6964 13.4432 13.44 13.6629 13.1111C13.8827 12.7822 14 12.3956 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10Z" fill="black" />
                        </svg>
                    </div>}
                    items={[{ anchor: t('finish'), onClick: () => onFinallyPlanning(data) }]}
                />
            </Col>
        </Row>
    );
};


const formatDate = (date) => date ? new Intl.DateTimeFormat(lang(), { dateStyle: "long" }).format(new Date(date)) : "-";


export const ModalAsync = ({ currentEvent, open, onClose, onAction, onChangeStatus, ...props }) => {
    const { t } = useTranslation("data_clinical");
    const [status, setStatus] = useState(null);

    const translatedStatusListAsync = useMemo(() => translateStatusListAsync(statusListAsync, t), [t]);

    useEffect(() => {
        if (currentEvent) {
            const translationKey = getStatusTranslationKey(currentEvent.status);
            const translatedStatusText = t(`statusList_Async.${translationKey}`);
            setStatus({ label: translatedStatusText, value: currentEvent.status });
        }
    }, [currentEvent, t]);

    const changeStatus = () => {
        const event = {}
        event['_id'] = currentEvent.planningId;
        event['status'] = status.value;
        event['session'] = currentEvent.sessionId;
        onAction(event);
    }

    return (
        <ModalSimple controlReverse={true} open={open} cancel={onClose} action={changeStatus} textAction={t('confirm')}>
            <Row>
                <Col md={1} >
                    <IconModal>
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_501_667)">
                                <path d="M14.0697 1.48038H0.930417C0.420207 1.48038 0.00512695 1.89546 0.00512695 2.40567V14.4346C0.00512695 14.9448 0.420207 15.3599 0.930417 15.3599H14.0697C14.5799 15.3599 14.995 14.9448 14.995 14.4346V2.4057C14.995 1.89549 14.5799 1.48038 14.0697 1.48038ZM13.8846 14.2495H1.11549V2.59074H13.8847V14.2495H13.8846Z" fill="#9AA2A8" />
                                <path d="M14.4398 5.18179H0.560303V6.29215H14.4398V5.18179Z" fill="#9AA2A8" />
                                <path d="M3.89136 0C3.58473 0 3.33618 0.24855 3.33618 0.55518V3.51615C3.33618 3.82278 3.58473 4.07133 3.89136 4.07133C4.19799 4.07133 4.44654 3.82278 4.44654 3.51615V0.55518C4.44654 0.24855 4.19799 0 3.89136 0Z" fill="#9AA2A8" />
                                <path d="M11.2937 0C10.9871 0 10.7385 0.24855 10.7385 0.55518V3.51615C10.7385 3.82278 10.9871 4.07133 11.2937 4.07133C11.6003 4.07133 11.8489 3.82278 11.8489 3.51615V0.55518C11.8489 0.24855 11.6003 0 11.2937 0Z" fill="#9AA2A8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_501_667">
                                    <rect width="15" height="15.36" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <InfoEventModal>
                        <h4>{currentEvent && currentEvent.title}</h4>
                    </InfoEventModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5" cy="5" r="5" fill={currentEvent && currentEvent.statusColor} />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        {currentEvent && currentEvent.status === 5 ? <>
                            <p className='bold'>{currentEvent && currentEvent.statusText}</p>
                        </> : <Dropdown
                            placeholder="Estado"
                            onChange={setStatus}
                            value={status}
                            options={translatedStatusListAsync}
                            portal
                            width="100%"
                        />}
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8671 4.97577H0.539307V6.04199H13.8671V4.97577Z" fill="#9AA2A8" />
                            <path d="M3.73794 0C3.4435 0 3.20483 0.238669 3.20483 0.53311V3.37637C3.20483 3.67081 3.4435 3.90948 3.73794 3.90948C4.03238 3.90948 4.27105 3.67081 4.27105 3.37637V0.53311C4.27105 0.238669 4.03238 0 3.73794 0Z" fill="#9AA2A8" />
                            <path d="M10.8459 0C10.5514 0 10.3127 0.238669 10.3127 0.53311V3.37637C10.3127 3.67081 10.5514 3.90948 10.8459 3.90948C11.1403 3.90948 11.379 3.67081 11.379 3.37637V0.53311C11.379 0.238669 11.1403 0 10.8459 0Z" fill="#9AA2A8" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5116 1.42148H0.89461C0.404683 1.42148 0.00610352 1.82006 0.00610352 2.30999V13.8607C0.00610352 14.3507 0.404683 14.7493 0.89461 14.7493H8.62558C8.75731 15.1605 8.9485 15.542 9.20374 15.8666C10.189 17.2066 11.5323 18 13.1929 18C15.8394 18 17.9932 15.8468 17.9932 13.1997C17.9932 12.0594 17.5929 11.0109 16.9269 10.1865C16.5628 9.75918 16.3716 9.59563 15.8605 9.21049L15.8598 9.21116C15.0968 8.6994 14.1788 8.4 13.1929 8.4C11.5079 8.4 10.0228 9.27315 9.16614 10.5908C8.59959 11.3576 8.32394 12.5441 8.4181 13.683H1.07232V2.4877H13.3339L13.3339 8.40183C13.701 8.41189 14.0579 8.46318 14.4001 8.55125V2.31002C14.4001 1.82009 14.0015 1.42148 13.5116 1.42148ZM13.7858 12.707H15.3857C15.6805 12.707 15.9192 12.9458 15.9192 13.2406C15.9192 13.5353 15.6805 13.7741 15.3857 13.7741H13.2523C12.9575 13.7741 12.7187 13.5353 12.7187 13.2406V11.1072C12.7187 10.8124 12.9575 10.5736 13.2523 10.5736C13.547 10.5736 13.7858 10.8124 13.7858 11.1072V12.707ZM16.9262 13.2003C16.9262 11.1421 15.2518 9.46703 13.1929 9.46703C11.1347 9.46703 9.45961 11.1421 9.45961 13.2003C9.45961 15.2586 11.134 16.9336 13.1929 16.9336C15.2511 16.9336 16.9262 15.2586 16.9262 13.2003Z" fill="#9AA2A8" />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p><span className='space date'>{formatDate(currentEvent && currentEvent.startStr)}</span></p>
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_501_1576)">
                                <path d="M10.6251 11.8848H9.21883C8.87379 11.8848 8.59375 11.6048 8.59375 11.2597C8.59375 10.9148 8.87379 10.6348 9.21883 10.6348H10.6251C12.3482 10.6348 13.75 9.23286 13.75 7.50973C13.75 5.78659 12.3482 4.3848 10.6251 4.3848H9.21883C8.87379 4.3848 8.59375 4.10477 8.59375 3.75973C8.59375 3.4148 8.87379 3.13477 9.21883 3.13477H10.6251C13.0375 3.13477 15 5.09731 15 7.50973C15 9.92226 13.0375 11.8848 10.6251 11.8848Z" fill="#9AA2A8" />
                                <path d="M5.78121 11.8848H4.37496C1.96255 11.8848 0 9.92226 0 7.50973C0 5.09731 1.96255 3.13477 4.37496 3.13477H5.78121C6.12625 3.13477 6.40629 3.4148 6.40629 3.75973C6.40629 4.10477 6.12625 4.3848 5.78121 4.3848H4.37496C2.65183 4.3848 1.25004 5.78659 1.25004 7.50973C1.25004 9.23286 2.65183 10.6348 4.37496 10.6348H5.78121C6.12625 10.6348 6.40629 10.9148 6.40629 11.2597C6.40629 11.6048 6.12625 11.8848 5.78121 11.8848Z" fill="#9AA2A8" />
                                <path d="M9.37496 8.1348H5.62496C5.27992 8.1348 5 7.85477 5 7.50973C5 7.1648 5.27992 6.88477 5.62496 6.88477H9.37496C9.72 6.88477 9.99992 7.1648 9.99992 7.50973C9.99992 7.85477 9.72 8.1348 9.37496 8.1348Z" fill="#9AA2A8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_501_1576">
                                    <rect width="15" height="15" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p className='bold'>{currentEvent && currentEvent.protocolName}</p>
                        <p className='suc'>{currentEvent && currentEvent.protocolFase}</p>
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_501_1576)">
                                <path d="M10.6251 11.8848H9.21883C8.87379 11.8848 8.59375 11.6048 8.59375 11.2597C8.59375 10.9148 8.87379 10.6348 9.21883 10.6348H10.6251C12.3482 10.6348 13.75 9.23286 13.75 7.50973C13.75 5.78659 12.3482 4.3848 10.6251 4.3848H9.21883C8.87379 4.3848 8.59375 4.10477 8.59375 3.75973C8.59375 3.4148 8.87379 3.13477 9.21883 3.13477H10.6251C13.0375 3.13477 15 5.09731 15 7.50973C15 9.92226 13.0375 11.8848 10.6251 11.8848Z" fill="#9AA2A8" />
                                <path d="M5.78121 11.8848H4.37496C1.96255 11.8848 0 9.92226 0 7.50973C0 5.09731 1.96255 3.13477 4.37496 3.13477H5.78121C6.12625 3.13477 6.40629 3.4148 6.40629 3.75973C6.40629 4.10477 6.12625 4.3848 5.78121 4.3848H4.37496C2.65183 4.3848 1.25004 5.78659 1.25004 7.50973C1.25004 9.23286 2.65183 10.6348 4.37496 10.6348H5.78121C6.12625 10.6348 6.40629 10.9148 6.40629 11.2597C6.40629 11.6048 6.12625 11.8848 5.78121 11.8848Z" fill="#9AA2A8" />
                                <path d="M9.37496 8.1348H5.62496C5.27992 8.1348 5 7.85477 5 7.50973C5 7.1648 5.27992 6.88477 5.62496 6.88477H9.37496C9.72 6.88477 9.99992 7.1648 9.99992 7.50973C9.99992 7.85477 9.72 8.1348 9.37496 8.1348Z" fill="#9AA2A8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_501_1576">
                                    <rect width="15" height="15" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p className='bold'>{currentEvent && currentEvent.trainingsSize} Ejercicios</p>
                        <p className='suc'>{currentEvent && currentEvent.modes.map(e => `${e.name}(${e.amount})`).join(',')}</p>
                    </HourInfoModal>
                </Col>
            </Row>
        </ModalSimple>
    )
}

const lang = () => {
    if (window) return window.navigator.language || window.navigator.userLanguage;
    else return "es";
}

export const ModalSync = ({ currentEvent, open, onClose, onAction, onChangeStatus, ...props }) => {
    const { t } = useTranslation("data_clinical");
    const [status, setStatus] = useState(null);

    const translatedStatusList = useMemo(() => translateStatusList(statusList, t), [t]);

    useEffect(() => {
        if (currentEvent) {
            setStatus({ label: currentEvent.data.statusText, value: currentEvent.data.status })
        }
    }, [currentEvent]);

    const changeStatus = () => {
        const event = {}
        event['_id'] = currentEvent._id;
        event['status'] = status.value;
        onAction(event);
    }

    const getIcon = (status) => {
        switch (status) {
            case 0: return <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.49117 0C3.90641 0 0.98999 2.79847 0.98999 6.23833C0.98999 10.9067 6.95495 14.7563 7.20904 14.9178C7.29509 14.9727 7.39303 15 7.49117 15C7.58914 15 7.68726 14.9725 7.7733 14.9178C8.02739 14.7563 13.9924 10.9067 13.9924 6.23833C13.9924 2.79847 11.0761 0 7.49117 0ZM7.491 13.8396C6.33638 13.0356 2.0414 9.80309 2.0414 6.23833C2.0414 3.37816 4.48607 1.05141 7.49117 1.05141C10.4963 1.05141 12.9409 3.37816 12.9409 6.23833C12.9409 9.79731 8.64509 13.0346 7.491 13.8396Z" fill="#9AA2A8" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.80005 5.65083C4.80005 4.22223 6.01126 3.06 7.50005 3.06C8.98891 3.06 10.2 4.22223 10.2 5.65083C10.2 7.58966 7.72275 9.1884 7.61722 9.2555C7.58148 9.27821 7.54074 9.28963 7.50005 9.28963C7.45929 9.28963 7.41861 9.27828 7.38288 9.2555C7.27735 9.1884 4.80005 7.58966 4.80005 5.65083ZM5.48819 5.63296C5.48819 6.94894 7.07374 8.14228 7.49998 8.43908C7.92603 8.14189 9.51191 6.94681 9.51191 5.63296C9.51191 4.57709 8.60942 3.71814 7.50005 3.71814C6.39068 3.71814 5.48819 4.57709 5.48819 5.63296Z" fill="#9AA2A8" />
            </svg>

            case 1: return <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.49117 0C3.90641 0 0.98999 2.79847 0.98999 6.23833C0.98999 10.9067 6.95495 14.7563 7.20904 14.9178C7.29509 14.9727 7.39303 15 7.49117 15C7.58914 15 7.68726 14.9725 7.7733 14.9178C8.02739 14.7563 13.9924 10.9067 13.9924 6.23833C13.9924 2.79847 11.0761 0 7.49117 0ZM7.491 13.8396C6.33638 13.0356 2.0414 9.80309 2.0414 6.23833C2.0414 3.37816 4.48607 1.05141 7.49117 1.05141C10.4963 1.05141 12.9409 3.37816 12.9409 6.23833C12.9409 9.79731 8.64509 13.0346 7.491 13.8396Z" fill="#9AA2A8" />
                <path d="M7.5152 3.06004L7.51172 3.06L7.51016 3.06001C5.85687 3.06085 4.5 4.39889 4.5 6.04828C4.5 6.45159 4.58033 6.84436 4.73878 7.21568C5.04554 7.9346 5.62386 8.51379 6.34431 8.8212C6.71558 8.97963 7.1083 9.05997 7.51155 9.05999L7.51269 9.05997C9.17149 9.05945 10.5 7.69272 10.5 6.04828C10.5 4.39915 9.1669 3.06191 7.5152 3.06004ZM6.9295 3.47535C6.62972 3.75955 6.38479 4.09241 6.20034 4.46625H5.38494C5.7589 3.97359 6.30278 3.61459 6.9295 3.47535ZM5.1596 4.81547H6.05012C5.92716 5.15235 5.85445 5.51141 5.83569 5.8725H4.85762C4.8829 5.49365 4.98925 5.13413 5.1596 4.81547ZM5.16622 7.30219C4.99173 6.97711 4.88295 6.6118 4.85753 6.22406H5.8345C5.85128 6.59315 5.92452 6.95802 6.05014 7.30219H5.16622ZM5.39214 7.65375H6.20034C6.38443 8.0269 6.62903 8.35964 6.92871 8.64391C6.30629 8.50419 5.76571 8.14574 5.39214 7.65375ZM6.18657 6.22406H7.33593V7.30219H6.42921C6.28884 6.96401 6.20543 6.60001 6.18657 6.22406ZM7.33595 8.534C7.03707 8.28515 6.78927 7.98633 6.60082 7.65375H7.33594L7.33595 8.534ZM7.33595 5.8725H6.18776C6.20884 5.50485 6.29177 5.14896 6.42923 4.81781H7.33595V5.8725ZM7.33595 4.46625H6.60084C6.78928 4.13367 7.03709 3.83484 7.33595 3.58598V4.46625ZM9.84311 4.81781C10.012 5.13648 10.1174 5.49365 10.1424 5.8725H9.18773C9.16897 5.51141 9.09627 5.15469 8.9733 4.81781H9.84311ZM9.61977 4.46625H8.82311C8.63916 4.09339 8.39483 3.76091 8.09551 3.4768C8.71389 3.61712 9.25042 3.97535 9.61977 4.46625ZM7.68751 3.58605C7.98638 3.83491 8.23427 4.13367 8.42271 4.46625H7.68751V3.58605ZM7.6875 4.81781H8.59444C8.73188 5.14894 8.81462 5.50487 8.8357 5.8725H7.6875V4.81781ZM8.83697 6.22172C8.81813 6.59764 8.73479 6.96403 8.59444 7.30219H7.6875V6.22172H8.83697ZM7.68751 8.53394V7.6514H8.42271C8.23427 7.98398 7.98638 8.28507 7.68751 8.53394ZM8.09631 8.64244C8.39503 8.35872 8.63919 8.02419 8.82309 7.6514H9.61262C9.2437 8.1416 8.71043 8.50163 8.09631 8.64244ZM8.97332 7.30219C9.09894 6.95802 9.17218 6.59081 9.18896 6.22172H10.1425C10.1173 6.60945 10.0095 6.97711 9.83657 7.30219H8.97332Z" fill="#9AA2A8" />
            </svg>

            case 2: return <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.49117 0C3.90641 0 0.98999 2.79847 0.98999 6.23833C0.98999 10.9067 6.95495 14.7563 7.20904 14.9178C7.29509 14.9727 7.39303 15 7.49117 15C7.58914 15 7.68726 14.9725 7.7733 14.9178C8.02739 14.7563 13.9924 10.9067 13.9924 6.23833C13.9924 2.79847 11.0761 0 7.49117 0ZM7.491 13.8396C6.33638 13.0356 2.0414 9.80309 2.0414 6.23833C2.0414 3.37816 4.48607 1.05141 7.49117 1.05141C10.4963 1.05141 12.9409 3.37816 12.9409 6.23833C12.9409 9.79731 8.64509 13.0346 7.491 13.8396Z" fill="#9AA2A8" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.31818 8.13954C5.31818 8.30318 5.42727 8.41227 5.59091 8.41227H9.40909C9.57273 8.41227 9.68182 8.30318 9.68182 8.13954V5.69812H10.29L10.2755 5.685H10.5L7.66364 3.12136C7.58182 3.03954 7.41818 3.03954 7.30909 3.12136L4.5 5.685H4.75438L4.74 5.69812H5.31818V8.13954ZM9.02864 7.7163H6.00136V5.24403L7.515 3.85653L9.02864 5.24403V7.7163Z" fill="#9AA2A8" />
            </svg>

            default: return <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.49117 0C3.90641 0 0.98999 2.79847 0.98999 6.23833C0.98999 10.9067 6.95495 14.7563 7.20904 14.9178C7.29509 14.9727 7.39303 15 7.49117 15C7.58914 15 7.68726 14.9725 7.7733 14.9178C8.02739 14.7563 13.9924 10.9067 13.9924 6.23833C13.9924 2.79847 11.0761 0 7.49117 0ZM7.491 13.8396C6.33638 13.0356 2.0414 9.80309 2.0414 6.23833C2.0414 3.37816 4.48607 1.05141 7.49117 1.05141C10.4963 1.05141 12.9409 3.37816 12.9409 6.23833C12.9409 9.79731 8.64509 13.0346 7.491 13.8396Z" fill="#9AA2A8" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.80005 5.65083C4.80005 4.22223 6.01126 3.06 7.50005 3.06C8.98891 3.06 10.2 4.22223 10.2 5.65083C10.2 7.58966 7.72275 9.1884 7.61722 9.2555C7.58148 9.27821 7.54074 9.28963 7.50005 9.28963C7.45929 9.28963 7.41861 9.27828 7.38288 9.2555C7.27735 9.1884 4.80005 7.58966 4.80005 5.65083ZM5.48819 5.63296C5.48819 6.94894 7.07374 8.14228 7.49998 8.43908C7.92603 8.14189 9.51191 6.94681 9.51191 5.63296C9.51191 4.57709 8.60942 3.71814 7.50005 3.71814C6.39068 3.71814 5.48819 4.57709 5.48819 5.63296Z" fill="#9AA2A8" />
            </svg>
        }
    }

    const getNameTypeEvent = (status) => {
        switch (status) {
            case 0: return "Consulta presencial";
            case 1: return "Consulta online";
            case 2: return "Consulta a domicilio";
            default: return "Consulta presencial";
        }
    }

    return (
        <ModalSimple controlReverse={true} textCancel={t('accept')} textAction={t('confirm')} open={open} cancel={onClose} action={changeStatus}>
            <Row>
                <Col md={1} >
                    <IconModal>
                        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_501_667)">
                                <path d="M14.0697 1.48038H0.930417C0.420207 1.48038 0.00512695 1.89546 0.00512695 2.40567V14.4346C0.00512695 14.9448 0.420207 15.3599 0.930417 15.3599H14.0697C14.5799 15.3599 14.995 14.9448 14.995 14.4346V2.4057C14.995 1.89549 14.5799 1.48038 14.0697 1.48038ZM13.8846 14.2495H1.11549V2.59074H13.8847V14.2495H13.8846Z" fill="#9AA2A8" />
                                <path d="M14.4398 5.18179H0.560303V6.29215H14.4398V5.18179Z" fill="#9AA2A8" />
                                <path d="M3.89136 0C3.58473 0 3.33618 0.24855 3.33618 0.55518V3.51615C3.33618 3.82278 3.58473 4.07133 3.89136 4.07133C4.19799 4.07133 4.44654 3.82278 4.44654 3.51615V0.55518C4.44654 0.24855 4.19799 0 3.89136 0Z" fill="#9AA2A8" />
                                <path d="M11.2937 0C10.9871 0 10.7385 0.24855 10.7385 0.55518V3.51615C10.7385 3.82278 10.9871 4.07133 11.2937 4.07133C11.6003 4.07133 11.8489 3.82278 11.8489 3.51615V0.55518C11.8489 0.24855 11.6003 0 11.2937 0Z" fill="#9AA2A8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_501_667">
                                    <rect width="15" height="15.36" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <InfoEventModal>
                        <h4>{currentEvent && currentEvent.title}</h4>
                    </InfoEventModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5" cy="5" r="5" fill={currentEvent && currentEvent.data && currentEvent.data.statusColor} />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        {currentEvent && currentEvent.data && currentEvent.data.status === 6 ? <>
                            <p className='bold'>{currentEvent && currentEvent.data && currentEvent.data.statusText}</p>
                        </> : <Dropdown
                            placeholder="Estado"
                            onChange={setStatus}
                            value={status}
                            options={translatedStatusList}
                            portal
                            width="100%"
                        />}

                    </HourInfoModal>
                </Col>

                {/* <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        {getIcon(currentEvent && currentEvent.data && currentEvent.data.typeEvent)}
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p><span className='space date'>{getNameTypeEvent(currentEvent && currentEvent.data && currentEvent.data.typeEvent)}</span></p>
                    </HourInfoModal>
                </Col> */}

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        {getIcon(currentEvent && currentEvent.data && currentEvent.data.typeEvent)}
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p className='bold'>{getNameTypeEvent(currentEvent && currentEvent.data && currentEvent.data.typeEvent)}</p>
                        {currentEvent && currentEvent.data && currentEvent.data.typeEvent !== 0 ? currentEvent && currentEvent.data && currentEvent.data.typeEvent === 1 ? <a target="_blank" rel="noopener noreferrer" href={currentEvent && currentEvent.data && currentEvent.data.typeEventDesc} className='suc'>{currentEvent && currentEvent.data && currentEvent.data.typeEventDesc}</a> : <p className='suc'>{currentEvent && currentEvent.data && currentEvent.data.typeEventDesc}</p> : null}
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8671 4.97577H0.539307V6.04199H13.8671V4.97577Z" fill="#9AA2A8" />
                            <path d="M3.73794 0C3.4435 0 3.20483 0.238669 3.20483 0.53311V3.37637C3.20483 3.67081 3.4435 3.90948 3.73794 3.90948C4.03238 3.90948 4.27105 3.67081 4.27105 3.37637V0.53311C4.27105 0.238669 4.03238 0 3.73794 0Z" fill="#9AA2A8" />
                            <path d="M10.8459 0C10.5514 0 10.3127 0.238669 10.3127 0.53311V3.37637C10.3127 3.67081 10.5514 3.90948 10.8459 3.90948C11.1403 3.90948 11.379 3.67081 11.379 3.37637V0.53311C11.379 0.238669 11.1403 0 10.8459 0Z" fill="#9AA2A8" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5116 1.42148H0.89461C0.404683 1.42148 0.00610352 1.82006 0.00610352 2.30999V13.8607C0.00610352 14.3507 0.404683 14.7493 0.89461 14.7493H8.62558C8.75731 15.1605 8.9485 15.542 9.20374 15.8666C10.189 17.2066 11.5323 18 13.1929 18C15.8394 18 17.9932 15.8468 17.9932 13.1997C17.9932 12.0594 17.5929 11.0109 16.9269 10.1865C16.5628 9.75918 16.3716 9.59563 15.8605 9.21049L15.8598 9.21116C15.0968 8.6994 14.1788 8.4 13.1929 8.4C11.5079 8.4 10.0228 9.27315 9.16614 10.5908C8.59959 11.3576 8.32394 12.5441 8.4181 13.683H1.07232V2.4877H13.3339L13.3339 8.40183C13.701 8.41189 14.0579 8.46318 14.4001 8.55125V2.31002C14.4001 1.82009 14.0015 1.42148 13.5116 1.42148ZM13.7858 12.707H15.3857C15.6805 12.707 15.9192 12.9458 15.9192 13.2406C15.9192 13.5353 15.6805 13.7741 15.3857 13.7741H13.2523C12.9575 13.7741 12.7187 13.5353 12.7187 13.2406V11.1072C12.7187 10.8124 12.9575 10.5736 13.2523 10.5736C13.547 10.5736 13.7858 10.8124 13.7858 11.1072V12.707ZM16.9262 13.2003C16.9262 11.1421 15.2518 9.46703 13.1929 9.46703C11.1347 9.46703 9.45961 11.1421 9.45961 13.2003C9.45961 15.2586 11.134 16.9336 13.1929 16.9336C15.2511 16.9336 16.9262 15.2586 16.9262 13.2003Z" fill="#9AA2A8" />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p><span className='space date'>{formatDate(currentEvent && currentEvent.data && currentEvent.data.date)}</span></p>
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8671 4.97577H0.539307V6.04199H13.8671V4.97577Z" fill="#9AA2A8" />
                            <path d="M3.73794 0C3.4435 0 3.20483 0.238669 3.20483 0.53311V3.37637C3.20483 3.67081 3.4435 3.90948 3.73794 3.90948C4.03238 3.90948 4.27105 3.67081 4.27105 3.37637V0.53311C4.27105 0.238669 4.03238 0 3.73794 0Z" fill="#9AA2A8" />
                            <path d="M10.8459 0C10.5514 0 10.3127 0.238669 10.3127 0.53311V3.37637C10.3127 3.67081 10.5514 3.90948 10.8459 3.90948C11.1403 3.90948 11.379 3.67081 11.379 3.37637V0.53311C11.379 0.238669 11.1403 0 10.8459 0Z" fill="#9AA2A8" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5116 1.42148H0.89461C0.404683 1.42148 0.00610352 1.82006 0.00610352 2.30999V13.8607C0.00610352 14.3507 0.404683 14.7493 0.89461 14.7493H8.62558C8.75731 15.1605 8.9485 15.542 9.20374 15.8666C10.189 17.2066 11.5323 18 13.1929 18C15.8394 18 17.9932 15.8468 17.9932 13.1997C17.9932 12.0594 17.5929 11.0109 16.9269 10.1865C16.5628 9.75918 16.3716 9.59563 15.8605 9.21049L15.8598 9.21116C15.0968 8.6994 14.1788 8.4 13.1929 8.4C11.5079 8.4 10.0228 9.27315 9.16614 10.5908C8.59959 11.3576 8.32394 12.5441 8.4181 13.683H1.07232V2.4877H13.3339L13.3339 8.40183C13.701 8.41189 14.0579 8.46318 14.4001 8.55125V2.31002C14.4001 1.82009 14.0015 1.42148 13.5116 1.42148ZM13.7858 12.707H15.3857C15.6805 12.707 15.9192 12.9458 15.9192 13.2406C15.9192 13.5353 15.6805 13.7741 15.3857 13.7741H13.2523C12.9575 13.7741 12.7187 13.5353 12.7187 13.2406V11.1072C12.7187 10.8124 12.9575 10.5736 13.2523 10.5736C13.547 10.5736 13.7858 10.8124 13.7858 11.1072V12.707ZM16.9262 13.2003C16.9262 11.1421 15.2518 9.46703 13.1929 9.46703C11.1347 9.46703 9.45961 11.1421 9.45961 13.2003C9.45961 15.2586 11.134 16.9336 13.1929 16.9336C15.2511 16.9336 16.9262 15.2586 16.9262 13.2003Z" fill="#9AA2A8" />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p><span className='space date'>{currentEvent && currentEvent.data && currentEvent.data.frecuency}</span></p>
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8671 4.97577H0.539307V6.04199H13.8671V4.97577Z" fill="#9AA2A8" />
                            <path d="M3.73794 0C3.4435 0 3.20483 0.238669 3.20483 0.53311V3.37637C3.20483 3.67081 3.4435 3.90948 3.73794 3.90948C4.03238 3.90948 4.27105 3.67081 4.27105 3.37637V0.53311C4.27105 0.238669 4.03238 0 3.73794 0Z" fill="#9AA2A8" />
                            <path d="M10.8459 0C10.5514 0 10.3127 0.238669 10.3127 0.53311V3.37637C10.3127 3.67081 10.5514 3.90948 10.8459 3.90948C11.1403 3.90948 11.379 3.67081 11.379 3.37637V0.53311C11.379 0.238669 11.1403 0 10.8459 0Z" fill="#9AA2A8" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5116 1.42148H0.89461C0.404683 1.42148 0.00610352 1.82006 0.00610352 2.30999V13.8607C0.00610352 14.3507 0.404683 14.7493 0.89461 14.7493H8.62558C8.75731 15.1605 8.9485 15.542 9.20374 15.8666C10.189 17.2066 11.5323 18 13.1929 18C15.8394 18 17.9932 15.8468 17.9932 13.1997C17.9932 12.0594 17.5929 11.0109 16.9269 10.1865C16.5628 9.75918 16.3716 9.59563 15.8605 9.21049L15.8598 9.21116C15.0968 8.6994 14.1788 8.4 13.1929 8.4C11.5079 8.4 10.0228 9.27315 9.16614 10.5908C8.59959 11.3576 8.32394 12.5441 8.4181 13.683H1.07232V2.4877H13.3339L13.3339 8.40183C13.701 8.41189 14.0579 8.46318 14.4001 8.55125V2.31002C14.4001 1.82009 14.0015 1.42148 13.5116 1.42148ZM13.7858 12.707H15.3857C15.6805 12.707 15.9192 12.9458 15.9192 13.2406C15.9192 13.5353 15.6805 13.7741 15.3857 13.7741H13.2523C12.9575 13.7741 12.7187 13.5353 12.7187 13.2406V11.1072C12.7187 10.8124 12.9575 10.5736 13.2523 10.5736C13.547 10.5736 13.7858 10.8124 13.7858 11.1072V12.707ZM16.9262 13.2003C16.9262 11.1421 15.2518 9.46703 13.1929 9.46703C11.1347 9.46703 9.45961 11.1421 9.45961 13.2003C9.45961 15.2586 11.134 16.9336 13.1929 16.9336C15.2511 16.9336 16.9262 15.2586 16.9262 13.2003Z" fill="#9AA2A8" />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p><span className='space date'>{currentEvent && currentEvent.data && currentEvent.data.numPack}</span></p>
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8671 4.97577H0.539307V6.04199H13.8671V4.97577Z" fill="#9AA2A8" />
                            <path d="M3.73794 0C3.4435 0 3.20483 0.238669 3.20483 0.53311V3.37637C3.20483 3.67081 3.4435 3.90948 3.73794 3.90948C4.03238 3.90948 4.27105 3.67081 4.27105 3.37637V0.53311C4.27105 0.238669 4.03238 0 3.73794 0Z" fill="#9AA2A8" />
                            <path d="M10.8459 0C10.5514 0 10.3127 0.238669 10.3127 0.53311V3.37637C10.3127 3.67081 10.5514 3.90948 10.8459 3.90948C11.1403 3.90948 11.379 3.67081 11.379 3.37637V0.53311C11.379 0.238669 11.1403 0 10.8459 0Z" fill="#9AA2A8" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5116 1.42148H0.89461C0.404683 1.42148 0.00610352 1.82006 0.00610352 2.30999V13.8607C0.00610352 14.3507 0.404683 14.7493 0.89461 14.7493H8.62558C8.75731 15.1605 8.9485 15.542 9.20374 15.8666C10.189 17.2066 11.5323 18 13.1929 18C15.8394 18 17.9932 15.8468 17.9932 13.1997C17.9932 12.0594 17.5929 11.0109 16.9269 10.1865C16.5628 9.75918 16.3716 9.59563 15.8605 9.21049L15.8598 9.21116C15.0968 8.6994 14.1788 8.4 13.1929 8.4C11.5079 8.4 10.0228 9.27315 9.16614 10.5908C8.59959 11.3576 8.32394 12.5441 8.4181 13.683H1.07232V2.4877H13.3339L13.3339 8.40183C13.701 8.41189 14.0579 8.46318 14.4001 8.55125V2.31002C14.4001 1.82009 14.0015 1.42148 13.5116 1.42148ZM13.7858 12.707H15.3857C15.6805 12.707 15.9192 12.9458 15.9192 13.2406C15.9192 13.5353 15.6805 13.7741 15.3857 13.7741H13.2523C12.9575 13.7741 12.7187 13.5353 12.7187 13.2406V11.1072C12.7187 10.8124 12.9575 10.5736 13.2523 10.5736C13.547 10.5736 13.7858 10.8124 13.7858 11.1072V12.707ZM16.9262 13.2003C16.9262 11.1421 15.2518 9.46703 13.1929 9.46703C11.1347 9.46703 9.45961 11.1421 9.45961 13.2003C9.45961 15.2586 11.134 16.9336 13.1929 16.9336C15.2511 16.9336 16.9262 15.2586 16.9262 13.2003Z" fill="#9AA2A8" />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p><span className='space date'>{currentEvent && currentEvent.data && currentEvent.data.speciality && currentEvent.data.speciality.name}</span></p>
                    </HourInfoModal>
                </Col>

                <Col md={12}><BarSeparateInfo /></Col>
                <Col md={1} >
                    <IconModal>
                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8671 4.97577H0.539307V6.04199H13.8671V4.97577Z" fill="#9AA2A8" />
                            <path d="M3.73794 0C3.4435 0 3.20483 0.238669 3.20483 0.53311V3.37637C3.20483 3.67081 3.4435 3.90948 3.73794 3.90948C4.03238 3.90948 4.27105 3.67081 4.27105 3.37637V0.53311C4.27105 0.238669 4.03238 0 3.73794 0Z" fill="#9AA2A8" />
                            <path d="M10.8459 0C10.5514 0 10.3127 0.238669 10.3127 0.53311V3.37637C10.3127 3.67081 10.5514 3.90948 10.8459 3.90948C11.1403 3.90948 11.379 3.67081 11.379 3.37637V0.53311C11.379 0.238669 11.1403 0 10.8459 0Z" fill="#9AA2A8" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5116 1.42148H0.89461C0.404683 1.42148 0.00610352 1.82006 0.00610352 2.30999V13.8607C0.00610352 14.3507 0.404683 14.7493 0.89461 14.7493H8.62558C8.75731 15.1605 8.9485 15.542 9.20374 15.8666C10.189 17.2066 11.5323 18 13.1929 18C15.8394 18 17.9932 15.8468 17.9932 13.1997C17.9932 12.0594 17.5929 11.0109 16.9269 10.1865C16.5628 9.75918 16.3716 9.59563 15.8605 9.21049L15.8598 9.21116C15.0968 8.6994 14.1788 8.4 13.1929 8.4C11.5079 8.4 10.0228 9.27315 9.16614 10.5908C8.59959 11.3576 8.32394 12.5441 8.4181 13.683H1.07232V2.4877H13.3339L13.3339 8.40183C13.701 8.41189 14.0579 8.46318 14.4001 8.55125V2.31002C14.4001 1.82009 14.0015 1.42148 13.5116 1.42148ZM13.7858 12.707H15.3857C15.6805 12.707 15.9192 12.9458 15.9192 13.2406C15.9192 13.5353 15.6805 13.7741 15.3857 13.7741H13.2523C12.9575 13.7741 12.7187 13.5353 12.7187 13.2406V11.1072C12.7187 10.8124 12.9575 10.5736 13.2523 10.5736C13.547 10.5736 13.7858 10.8124 13.7858 11.1072V12.707ZM16.9262 13.2003C16.9262 11.1421 15.2518 9.46703 13.1929 9.46703C11.1347 9.46703 9.45961 11.1421 9.45961 13.2003C9.45961 15.2586 11.134 16.9336 13.1929 16.9336C15.2511 16.9336 16.9262 15.2586 16.9262 13.2003Z" fill="#9AA2A8" />
                        </svg>
                    </IconModal>
                </Col>
                <Col md={11} >
                    <HourInfoModal>
                        <p><span className='space date'>{currentEvent && currentEvent.data && currentEvent.data.suc && currentEvent.data.suc.name}</span></p>
                        <p className='suc'>{currentEvent && currentEvent.data && currentEvent.data.suc && currentEvent.data.suc.address}</p>
                    </HourInfoModal>
                </Col>
            </Row>
        </ModalSimple>
    )
}

export const ChartComplex = ({ completion, percentSuccess, percentLost, percentPending, percentRecovery, success, lost, pending, recovery, ...props }) => {
    const { t } = useTranslation("data_clinical");
    return (
        <>
            <Row>
                <Col col={12} className="d-flex justify-content-center">
                    <h6 className="m-0 pt-3 color-tit-text">{t("completion")}</h6>
                </Col>
            </Row>

            <Row>
                <Col className="d-flex justify-content-center align-items-center p-3">
                    <ChartDonut
                        data={[percentSuccess, percentPending, percentRecovery, percentLost]}
                        labels={[t("performed"), t("pending"), t("recovered"), t("losses")]}
                        legendPosition="bottom"
                        value={completion}
                    />
                </Col>
            </Row>

            <Row className="px-3">
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <div className="circle green mb-2"></div>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <div className="circle blue mb-2"></div>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <div className="circle orange mb-2"></div>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <div className="circle red mb-2"></div>
                </Col>
            </Row>
            <Row className="px-3">
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 color-primario fz-9 fw-700">{t("completed")}</p>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 color-primario fz-9 fw-700">{t("next")}</p>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 color-primario fz-9 fw-700 text-center">{t("recoverable")}</p>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 color-primario fz-9 fw-700">{t("lost")}</p>
                </Col>
            </Row>
            <Row className="px-3">
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 fz-14 color-primario">
                        <strong>{success}</strong>
                    </p>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 fz-14 color-primario">
                        <strong>{pending}</strong>
                    </p>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 fz-14 color-primario">
                        <strong>{recovery}</strong>
                    </p>
                </Col>
                <Col md={3} className="d-flex justify-content-center align-items-center">
                    <p className="m-0 fz-14 color-primario">
                        <strong>{lost}</strong>
                    </p>
                </Col>
            </Row>
        </>
    );
};

export const UserData = ({ avatar, name, score, ...props }) => {
    const { t } = useTranslation("data_clinical");
    return (
        <>
            <div className="col-md-12 py-2">
                <div className="profile">
                    <div className="row pt-2">
                        <div className="col-sm-3 pr-0 d-flex justify-content-center d-flex align-items-center">
                            <div
                                className="circle-profile"
                                style={{
                                    backgroundImage: "url(" + avatar + ")",
                                    width: 40,
                                    height: 40,
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover",
                                }}
                            ></div>
                        </div>
                        <div className="col-sm-9 p-0">
                            <p className="m-0 fz-16">
                                <strong>{name}</strong>
                            </p>
                            <p className="m-0 fz-14">
                                {t("score")}
                                <strong className="fz-18 color-primario"> {score}</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export const ItemsPlannningsAndEvenstComponent = ({ planningsChild, schedulesChild, ...props }) => {
    const { t } = useTranslation("data_clinical");
    return (
        <>
            <Col md={12} className="mt-4">
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                    <li className="nav-item text-center" style={{ width: "50%" }} role="presentation">
                        <a className="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
                            {t("plans")}
                        </a>
                    </li>
                    <li className="nav-item text-center" style={{ width: "50%" }} role="presentation">
                        <a className="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                            {t("programs")}
                        </a>
                    </li>
                </ul>
                <div className="tab-content scroll-card-sm" id="pills-tabContent" style={{ background: "#F9FBFF", maxHeight: "calc(100vh - 530px)" }}>
                    <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <div className="container">{planningsChild}</div>
                    </div>
                    <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                        <div className="container">{schedulesChild}</div>
                    </div>
                </div>
            </Col>
        </>
    );
};

export const ModalConfirm = ({ open, setOpen, onAction, data, ...props }) => {
    const { t } = useTranslation("data_clinical");
    const getType = () => {
        return data && data.type === 0 ? t('thePlanning') : t('theProgram');
    }
    return (
        <ModalSimple title={t("confirmation")} open={open} cancel={setOpen} action={() => onAction(data)} textAction={t("accept")} >
            <Row>
                <Col md={12}>
                    <InfoEventModal>
                        <h4> {t('wantFinish')} {getType()} {data && data.data && data.data.name}?</h4>
                    </InfoEventModal>
                </Col>
            </Row>
        </ModalSimple>
    )
}